import React, { useEffect, useRef, useState } from "react";

function Skills() {
  const ref1 = useRef(null);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setReload(true);
        }
      },
      { threshold: 0.2 }
    );

    if (ref1.current) observer.observe(ref1.current);
    
    return () => observer.disconnect();
  }, []);

  const skillCategories = [
    {
      category: "Programming Languages",
      skills: [
        { name: "Python", value: 95 },
        { name: "JavaScript/TypeScript", value: 99 },
        { name: "Java", value: 90 },
        { name: "C++", value: 90 },
        { name: "GoLang", value: 70 },
      ],
    },
    {
      category: "Full Stack Development",
      skills: [
        { name: "React", value: 98 },
        // { name: "Vue", value: 80 },
        // { name: "Angular", value: 78 },
        { name: "Node.js", value: 95 },
        // { name: "Express.js", value: 80 },
        { name: "SpringBoot", value: 90 },
        { name: "FastAPI", value: 98 },
        { name: "Flask/Django", value: 98 },
      ],
    },
    {
      category: "DevOps & Cloud",
      skills: [
        { name: "AWS", value: 90 },
        { name: "GCP", value: 90 },
        { name: "Docker", value: 98 },
        { name: "Kubernetes", value: 90 },
        { name: "Terraform", value: 90 },
        { name: "Jenkins", value: 90 },
        { name: "RabbitMQ", value: 90 },
        { name: "Kafka", value: 90 },
      ],
    },
    {
      category: "Databases",
      skills: [
        { name: "MySQL", value: 90 },
        { name: "PostgreSQL", value: 85 },
        { name: "MongoDB", value: 90 },
        { name: "Redis", value: 85 },
      ],
    },
  ];

  return (
    <div ref={ref1} style={styles.container}>
      <h2 style={styles.title}>Technical Skills</h2>
      <div className="grid-creator">
      {skillCategories.map((category, index) => (
        <div key={index} style={styles.categoryContainer}>
          <h3 style={styles.categoryTitle}>{category.category}</h3>

          {/* Multi-column layout using CSS Grid */}
          <div style={styles.gridContainer}>
            {category.skills.map((item, idx) => (
              <div key={idx} style={styles.skillCard}>
                <p style={styles.skillName}>{item.name}</p>
                <div style={styles.progressBar}>
                  <div
                    style={{
                      ...styles.progressFill,
                      width: `${item.value}%`,
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      </div>
    </div>
  );
}

// Inline styles to replace Tailwind
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 20px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#333",
  },
  categoryContainer: {
    width: "100%",
    maxWidth: "900px",
    marginBottom: "30px",
  },
  categoryTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    marginBottom: "15px",
    color: "#444",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
  },
  skillCard: {
    backgroundColor: "#fff",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  skillName: {
    fontSize: "16px",
    fontWeight: "500",
    marginBottom: "8px",
  },
  progressBar: {
    width: "100%",
    backgroundColor: "#e0e0e0",
    borderRadius: "6px",
    height: "8px",
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    backgroundColor: "#007bff",
    transition: "width 0.5s ease-in-out",
  },
};

export default Skills;
